export const events = {
  users: 'users-data-received',
  'validate-email': 'email-validation-result',
  'validate-phone': 'phone-validation-result',
  'validate-phone-work': 'phone-work-validation-result',
  'validate-phone-mobile': 'phone-mobile-validation-result'
}
